import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Icon from 'components/Icon';
import Seo from 'components/Seo';

const ALL_TOOLS = [
  // PDF
  { icon:'image',    name:'Image to PDF',      desc:'Convert any image to a PDF document',          cat:'pdf',   path:'/tools/pdf/image-to-pdf' },
  { icon:'word',     name:'PDF to Word',        desc:'Extract text from PDF as editable document',   cat:'pdf',   path:'/tools/pdf/to-word' },
  { icon:'compress', name:'PDF Compressor',     desc:'Reduce PDF file size instantly',               cat:'pdf',   path:'/tools/pdf/compress' },
  { icon:'merge',    name:'Merge PDF',          desc:'Combine multiple PDFs into one file',          cat:'pdf',   path:'/tools/pdf/merge' },
  { icon:'scissors', name:'Split PDF',          desc:'Extract specific pages from a PDF',            cat:'pdf',   path:'/tools/pdf/split' },
  { icon:'zip',      name:'Files to ZIP',       desc:'Pack multiple files into one ZIP archive',     cat:'pdf',   path:'/tools/pdf/to-zip' },
  { icon:'image',    name:'PDF to JPG',         desc:'Convert each PDF page into a JPG image',       cat:'pdf',   path:'/tools/pdf/to-jpg' },
  // Image
  { icon:'convert',  name:'JPG to PNG',         desc:'Convert JPG images to lossless PNG',           cat:'image', path:'/tools/image/jpg-to-png' },
  { icon:'convert',  name:'PNG to JPG',         desc:'Convert PNG images to smaller JPG format',     cat:'image', path:'/tools/image/png-to-jpg' },
  { icon:'resize',   name:'Image Resize',       desc:'Resize image to exact dimensions or preset',   cat:'image', path:'/tools/image/resize' },
  { icon:'compress', name:'Image Compressor',   desc:'Reduce image size with quality control',        cat:'image', path:'/tools/image/compress' },

  // Text
  { icon:'type',     name:'Word Counter',       desc:'Count words, characters, sentences in real time', cat:'text', path:'/tools/text/word-counter' },
  { icon:'type',     name:'Case Converter',     desc:'Convert text to UPPERCASE, lowercase, Title Case', cat:'text', path:'/tools/text/case-converter' },
  // Utility
  { icon:'image',    name:'QR Code Generator',  desc:'Create a QR code for any link or text',        cat:'utility', path:'/tools/utility/qr-code' },
  { icon:'user',     name:'Resume Builder',     desc:'Build a professional resume and download as PDF', cat:'utility', path:'/tools/utility/resume-builder' },
];

const CATS = [
  { id:'all',     label:'All Tools',     icon:'tools' },
  { id:'pdf',     label:'PDF Tools',     icon:'pdf' },
  { id:'image',   label:'Image Tools',   icon:'image' },
  { id:'text',    label:'Text Tools',    icon:'type' },
  { id:'utility', label:'Utility Tools', icon:'tools' },
];

const BADGE = { pdf:'PDF', image:'Image', text:'Text', utility:'Utility' };

export default function ToolsPage() {
  const [params] = useSearchParams();
  const [cat, setCat]     = useState(params.get('cat') || 'all');
  const [search, setSearch] = useState(params.get('search') || '');

  const filtered = ALL_TOOLS.filter(t => {
    const matchCat = cat === 'all' || t.cat === cat;
    const q = search.toLowerCase();
    const matchSearch = !q || t.name.toLowerCase().includes(q) || t.desc.toLowerCase().includes(q);
    return matchCat && matchSearch;
  });

  return (
    <>
    <Seo title="All Free Online Tools" description="Browse all free PDF, image, text and utility tools on Devlayar. No signup." path="/tools" />
    <div className="tool-pg">
      <div className="container">
        <div className="tool-hdr">
          <div className="tool-hdr-row">
            <div className="tool-hdr-icon"><Icon name="tools" size={24} /></div>
            <div>
              <h1>All Tools</h1>
              <p>{ALL_TOOLS.length} free tools — no signup, no watermarks, no limits</p>
            </div>
          </div>
        </div>

        {/* Search */}
        <div style={{ position:'relative', maxWidth:360, marginBottom:20 }}>
          <div style={{ position:'absolute', left:12, top:'50%', transform:'translateY(-50%)', color:'var(--slate-400)', pointerEvents:'none' }}>
            <Icon name="search" size={16} />
          </div>
          <input type="text" className="form-control" placeholder="Search tools..." value={search} onChange={e => setSearch(e.target.value)} style={{ paddingLeft:38, fontSize:14 }} />
        </div>

        {/* Filters */}
        <div className="filters" style={{ marginBottom:32 }}>
          {CATS.map(c => (
            <button key={c.id} className={`filter-btn ${cat === c.id ? 'active' : ''}`} onClick={() => setCat(c.id)}>
              <Icon name={c.icon} size={13} />{c.label}
            </button>
          ))}
        </div>

        <p style={{ fontSize:13, color:'var(--slate-400)', marginBottom:20, fontWeight:500 }}>
          {filtered.length} tool{filtered.length !== 1 ? 's' : ''}{search ? ` for "${search}"` : ''}
        </p>

        {filtered.length === 0 ? (
          <div style={{ textAlign:'center', padding:'80px 20px' }}>
            <div style={{ width:56, height:56, background:'var(--slate-100)', borderRadius:'var(--r)', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px', color:'var(--slate-300)' }}>
              <Icon name="search" size={24} />
            </div>
            <h3 style={{ marginBottom:8 }}>No tools found</h3>
            <p style={{ color:'var(--slate-400)', marginBottom:16 }}>Try a different search term</p>
            <button className="btn btn-secondary btn-sm" onClick={() => { setSearch(''); setCat('all'); }}>
              <Icon name="refresh" size={14} />Clear filters
            </button>
          </div>
        ) : (
          <div className="tools-grid">
            {filtered.map(t => (
              <Link to={t.path} key={t.name} className="tool-card">
                <div className={`tool-icon cat-${t.cat}`}><Icon name={t.icon} size={19} /></div>
                <h3>{t.name}</h3>
                <p>{t.desc}</p>
                <span className={`tool-badge cat-${t.cat}`}>{BADGE[t.cat]}</span>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  </>
  );
}
